<template>
  <Fragment>
    <div class="cd_container py-5">
      <h1 class="pb-2">Report Catches</h1>
      <div class="cd_report-fish">
        <ReportFishForm :center="position" />
        <div v-if="loading === null">
          <font-awesome-icon icon="spinner" pulse />
          Loading Your Location...
        </div>
        <GmapMap v-else id="report-map" ref="reportfish" :center="center" :zoom="zoom" :options="options">
          <GmapMarker :position="position" :clickable="true" :draggable="true" @drag="updateCoordinates"/>
        </GmapMap>
      </div>
    </div>
    <Spotlight>
      <div>
        <h2 class="py-2">Want to know more about Fish Reporting?</h2>
        <router-link :to="{ name: 'guide' }" class="btn btn-lg btn-info">Read the Reporting Guide</router-link>
      </div>
    </Spotlight>
  </Fragment>
</template>

<script>
  import { Fragment } from 'vue-fragment'
  import ReportFishForm from '../report-fish-form'
  import Spotlight from '../spotlight'
  import { gmapApi } from 'gmap-vue'
  import { BLUEWATER } from '@/constants/map-settings';

  export default {
    name: 'ReportFish',
    components: {
      Fragment,
      ReportFishForm,
      Spotlight
    },
    data(){
      return {
        zoom: 11,
        center: {lat: 39.563739804406154, lng: -79.84381050000002},
        position: {lat: 39.563739, lng: -79.8438105},
        loading: null,
        options: {styles: BLUEWATER}
      }
    },
    methods: {
      updateCoordinates(coordinates){
        this.position = {
          lat: coordinates.latLng.lat(),
          lng: coordinates.latLng.lng()
        }
      }
    },
    computed: {
      google: gmapApi
    },
    async mounted() {
      await this.$getLocation({enableHighAccuracy: true})
      .then(coordinates => {
        this.position = {lat: coordinates.lat, lng: coordinates.lng}
        this.loading = true
      }).catch(err => {
        this.loading = false
        if(err === "no position access"){
          this.center = {}
        } else {
          console.log(err)
        }
      })
      await this.$gmapApiPromiseLazy();
      this.$refs.reportfish.$mapPromise.then((map) => {
        new this.google.maps.KmlLayer({
          url: 'https://assets.creekdog.org/deckers-creek-watershed.kml',
          preserveViewport: true,
          map: map
        })
      })
    }
  }
</script>

<style>
  #report-map {
    min-height: 300px;
  }
</style>
